import { ChangeEventItem } from "@/types";
import { Trans, useTranslation } from "react-i18next";
import dayjs from "dayjs";
import Button from "@edusogno/primitives/button";
import LoadingButton from "@edusogno/primitives/loading-button";
import AbsoluteBackground from "@/components/ui/AbsoluteBackground.tsx";
import CalendarIllustration from "@/components/ui/CalendarIllustration.tsx";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";

interface StepThreeProps {
  event: ChangeEventItem | undefined;
  onConfirm: () => void;
  onBack: () => void;
  loading: boolean;
}

const StepThree = ({ onBack, onConfirm, loading, event }: StepThreeProps) => {
  const date = dayjs(event?.data);
  const { t } = useTranslation();
  return (
    <DashboardContentLayout className={"relative z-10"}>
      <AbsoluteBackground className={"bg-white -z-30"} />

      <header className={"flex flex-col mt-2"}>
        <p className={"text-primary text-2xl font-semibold"}>
          {t("change_event.final_confirm")}
        </p>

        <p className="sub-heading !text-secondary">
          <Trans
            i18nKey="change_event.final_confirm_message"
            components={{
              b: <b className="text-primary" />,
            }}
          />
        </p>
      </header>

      <div className=" flex flex-col items-center justify-between h-full w-full my-[25px]">
        <CalendarIllustration
          day={date.format("DD")}
          month={date.format("MMM")}
          header={date.format("ddd")}
          className={
            "w-[26vh] border-solid bg-[var(--clr-violet-300)] border-primary border-2 rounded-[7px]"
          }
        />

        <div className="flex flex-col gap-8 text-center h-fit my-auto items-center">
          <div className={" gap-0 flex-col"}>
            <h5 className={"text-lg"}> {t("diploma_request.modal.time")}</h5>

            <p className={"text-3xl font-semibold text-brand-secondary"}>
              {event?.time}
            </p>
          </div>

          <div className={"detail gap-0  flex-col"}>
            <h5 className={"text-lg"}>
              {t("diploma_request.modal.duration")}
            </h5>
            
            <p className={"text-3xl font-semibold text-brand-secondary"}>
              {event?.duration}&nbsp;{t("diploma_request.modal.minutes")}
            </p>
          </div>
        </div>
      </div>

      <div className="flex gap-2 mt-auto max-w-[95vw] w-full mx-auto">
        <Button
          variant="contained"
          color="primary"
          size="md"
          onClick={onBack}
          disabled={loading}
        >
          {t("btns.edit")}
        </Button>

        <LoadingButton
          size="md"
          color="green"
          variant="contained"
          onClick={onConfirm}
          disabled={loading}
          className="flex gap-1 justify-center items-center"
          loading={loading}
        >
          {t("btns.confirm")}
        </LoadingButton>
      </div>
    </DashboardContentLayout>
  );
};

export default StepThree;
